import React from 'react'
import { iIsAuthenticated } from '../is-authenticated/IsAuthenticated'
import { useArq } from '../use-arq/use-arq'

const IsNotAuthenticated: iIsAuthenticated = ({ children }) => {
  const { auth } = useArq()

  if (!auth.getData().isAuthenticated) return <>{children}</>

  return null
}

export { IsNotAuthenticated }
